import type { TaxCollectionChanges } from '@/lib/services/organization-tax-settings/organization-tax-settings.types'
import { toast } from 'sonner'
import { stackToastAction } from '@/components/ui/toast'

interface TaxCollectionChangeNoticeResponse {
  tax_collection_changes?: TaxCollectionChanges | null
  data?: { tax_collection_changes?: TaxCollectionChanges | null } | null
}

export function showTaxCollectionChangeNotice(
  response: TaxCollectionChangeNoticeResponse | null | undefined,
  {
    canReview,
    onReview,
  }:
    | { canReview: true; onReview: () => void | Promise<void> }
    | { canReview: false; onReview?: () => void | Promise<void> }
): void {
  const changes = response?.tax_collection_changes ?? response?.data?.tax_collection_changes
  if (!changes?.added_states?.length && !changes?.removed_states?.length) return

  const description = [
    changes.added_states?.length ? `Added ${changes.added_states.join(', ')}.` : '',
    changes.removed_states?.length ? `Removed ${changes.removed_states.join(', ')}.` : '',
    canReview
      ? 'Review your tax collection states.'
      : 'Ask an organization administrator to review your tax collection states.',
  ]
    .filter(Boolean)
    .join(' ')

  const options = {
    description,
    duration: 15000,
    ...(canReview ? { action: { label: 'Review tax settings', onClick: onReview } } : {}),
  }

  toast.info('Tax collection settings updated', canReview ? stackToastAction(options) : options)
}
